// Niko's Grill — Speisekarte (extrahiert aus offiziellem PDF, Stand 2026)
// Bild-Schlüssel verweisen auf das IMAGES-Objekt unten.
// Mehrere Gerichte können sich ein Foto teilen, wenn sie optisch identisch sind.

export const IMAGES = {
  // Gyros & Grill
  "gyros-plate":
    "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1200&q=80",
  "gyros-pita":
    "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=1200&q=80",
  "gyros-pan":
    "https://images.unsplash.com/photo-1432139509613-5c4255815697?auto=format&fit=crop&w=1200&q=80",
  "gyros-baked":
    "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1200&q=80",
  "souvlaki":
    "https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?auto=format&fit=crop&w=1200&q=80",
  "bifteki":
    "https://images.unsplash.com/photo-1551183053-bf91a1d81141?auto=format&fit=crop&w=1200&q=80",
  "cevapcici":
    "https://images.unsplash.com/photo-1601315379734-425298158c39?auto=format&fit=crop&w=1200&q=80",
  "steak":
    "https://images.unsplash.com/photo-1546964124-0cce460f38ef?auto=format&fit=crop&w=1200&q=80",
  "schnitzel":
    "https://images.unsplash.com/photo-1599921841143-819065a55cc6?auto=format&fit=crop&w=1200&q=80",
  "schnitzel-menu":
    "https://images.unsplash.com/photo-1604908554007-1d4ffce2aae6?auto=format&fit=crop&w=1200&q=80",
  "chicken-grill":
    "https://images.unsplash.com/photo-1532550907401-a500c9a57435?auto=format&fit=crop&w=1200&q=80",
  "leber":
    "https://images.unsplash.com/photo-1607116176606-26b22cb0bcec?auto=format&fit=crop&w=1200&q=80",
  "lachs":
    "https://images.unsplash.com/photo-1485921325833-c519f76c4927?auto=format&fit=crop&w=1200&q=80",
  "burger":
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=1200&q=80",
  "burger-bbq":
    "https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?auto=format&fit=crop&w=1200&q=80",
  "burger-veggie":
    "https://images.unsplash.com/photo-1525059696034-4967a8e1dca2?auto=format&fit=crop&w=1200&q=80",

  // Vorspeisen
  "vorspeisenplatte":
    "https://images.unsplash.com/photo-1544510808-91bcbee1df55?auto=format&fit=crop&w=1200&q=80",
  "zaziki":
    "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?auto=format&fit=crop&w=1200&q=80",
  "saganaki":
    "https://images.unsplash.com/photo-1606851094291-6efae152bb87?auto=format&fit=crop&w=1200&q=80",
  "dolmadakia":
    "https://images.unsplash.com/photo-1574484284002-952d92456975?auto=format&fit=crop&w=1200&q=80",
  "fetacrema":
    "https://images.unsplash.com/photo-1626200491030-b9d83a2efad9?auto=format&fit=crop&w=1200&q=80",
  "oliven":
    "https://images.unsplash.com/photo-1605207616227-7a05c0a7c64c?auto=format&fit=crop&w=1200&q=80",
  "aubergine":
    "https://images.unsplash.com/photo-1625944525533-473f1b3d9684?auto=format&fit=crop&w=1200&q=80",
  "gigantes":
    "https://images.unsplash.com/photo-1572441710534-149bbcd09be1?auto=format&fit=crop&w=1200&q=80",
  "bruschetta":
    "https://images.unsplash.com/photo-1572441711685-5e15f96e2a08?auto=format&fit=crop&w=1200&q=80",
  "pita-bread":
    "https://images.unsplash.com/photo-1583252244517-99b16fd4e928?auto=format&fit=crop&w=1200&q=80",
  "tomatensuppe":
    "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1200&q=80",

  // Salate
  "bauernsalat":
    "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=1200&q=80",
  "mista-salat":
    "https://images.unsplash.com/photo-1551248429-40975aa4de74?auto=format&fit=crop&w=1200&q=80",
  "salat-chicken":
    "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1200&q=80",
  "salat-lachs":
    "https://images.unsplash.com/photo-1604908815791-b7c1bf5f9f44?auto=format&fit=crop&w=1200&q=80",
  "salat-ziege":
    "https://images.unsplash.com/photo-1505253716362-afaea1d3d1af?auto=format&fit=crop&w=1200&q=80",
  "salat-thunfisch":
    "https://images.unsplash.com/photo-1623428187969-5da2dcea5ebf?auto=format&fit=crop&w=1200&q=80",
  "salat-saganaki":
    "https://images.unsplash.com/photo-1559054663-e8d23213f55c?auto=format&fit=crop&w=1200&q=80",

  // Pasta
  "pasta-aglio":
    "https://images.unsplash.com/photo-1551183053-bf91a1d81141?auto=format&fit=crop&w=1200&q=80",
  "pasta-bolognese":
    "https://images.unsplash.com/photo-1551892374-ecf8754cf8b0?auto=format&fit=crop&w=1200&q=80",
  "pasta-carbonara":
    "https://images.unsplash.com/photo-1612874742237-6526221588e3?auto=format&fit=crop&w=1200&q=80",
  "pasta-lachs":
    "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?auto=format&fit=crop&w=1200&q=80",

  // Beilagen
  "pommes":
    "https://images.unsplash.com/photo-1573080496219-bb080dd4f877?auto=format&fit=crop&w=1200&q=80",
  "kroketten":
    "https://images.unsplash.com/photo-1639024471283-03518883512d?auto=format&fit=crop&w=1200&q=80",
  "reis":
    "https://images.unsplash.com/photo-1516684732162-798a0062be99?auto=format&fit=crop&w=1200&q=80",
  "bratkartoffeln":
    "https://images.unsplash.com/photo-1518779578993-ec3579fee39f?auto=format&fit=crop&w=1200&q=80",
  "süßkartoffel":
    "https://images.unsplash.com/photo-1604908554027-9b3eb6b2a2c0?auto=format&fit=crop&w=1200&q=80",
  "wedges":
    "https://images.unsplash.com/photo-1639024471283-03518883512d?auto=format&fit=crop&w=1200&q=80",
  "folienkartoffel":
    "https://images.unsplash.com/photo-1576502200916-3808e07386a5?auto=format&fit=crop&w=1200&q=80",
  "backkartoffel-spinat":
    "https://images.unsplash.com/photo-1551879400-111a9087cd86?auto=format&fit=crop&w=1200&q=80",
  "hähnchen-streifen":
    "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&w=1200&q=80",

  // Würste & Kinder
  "currywurst":
    "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?auto=format&fit=crop&w=1200&q=80",
  "bratwurst":
    "https://images.unsplash.com/photo-1599909533037-bb50e8253b80?auto=format&fit=crop&w=1200&q=80",
  "frikadelle":
    "https://images.unsplash.com/photo-1607116176606-26b22cb0bcec?auto=format&fit=crop&w=1200&q=80",
  "nuggets":
    "https://images.unsplash.com/photo-1562967914-608f82629710?auto=format&fit=crop&w=1200&q=80",
  "schaschlik":
    "https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?auto=format&fit=crop&w=1200&q=80",
  "pommes-metaxa":
    "https://images.unsplash.com/photo-1639667100869-e21afe69e6bb?auto=format&fit=crop&w=1200&q=80",

  // Saucen
  "saucen":
    "https://images.unsplash.com/photo-1564844536311-de7f87a64fbd?auto=format&fit=crop&w=1200&q=80",
};

// Helper to add allergen markers if useful (keep as-is for German allergens display)
export const CATEGORIES = [
  {
    id: "vorspeisen",
    title: "Vorspeisen & Suppen",
    accent: "🫒",
    blurb: "Mezedes wie in Griechenland — zum Teilen und Genießen.",
  },
  {
    id: "salate",
    title: "Salate",
    accent: "🥗",
    blurb: "Frisch, mediterran, mit hauseigenem Balsamico-Dressing.",
  },
  {
    id: "pita",
    title: "Pita & Brottaschen",
    accent: "🥙",
    blurb: "Goldbraun gebackene Pita-Spezialitäten.",
  },
  {
    id: "gyros",
    title: "Gyros vom Grill",
    accent: "🔥",
    blurb: "Saftiges Gyros — unser Hausklassiker, in vielen Varianten.",
  },
  {
    id: "grill",
    title: "Grill-Spezialitäten",
    accent: "🍖",
    blurb: "Hochwertiges Fleisch direkt vom Grill — mit Beilage und Salat.",
  },
  {
    id: "schnitzel",
    title: "Schnitzel",
    accent: "🍽️",
    blurb: "Vom Schwein, zart und knusprig — wahlweise mit unseren Saucen.",
  },
  {
    id: "burger",
    title: "Burger",
    accent: "🍔",
    blurb: "150 g medium gegrilltes Patty, auch als Veggie erhältlich.",
  },
  {
    id: "pasta",
    title: "Pasta",
    accent: "🍝",
    blurb: "Hausgemachte Pastagerichte — inklusive Salat und Brotbeilage.",
  },
  {
    id: "vegetarisch",
    title: "Vegetarisch & Spezial",
    accent: "🌿",
    blurb: "Kartoffel-Spezialitäten und vegetarische Klassiker.",
  },
  {
    id: "würste",
    title: "Würste & Kinder",
    accent: "🌭",
    blurb: "Kleine Portionen und Klassiker für jeden Hunger.",
  },
  {
    id: "beilagen",
    title: "Beilagen",
    accent: "🍟",
    blurb: "Mit Salatbouquette und hauseigenem Balsamico-Dressing.",
  },
  {
    id: "saucen",
    title: "Saucen & Dips",
    accent: "🍯",
    blurb: "Hausgemachte Saucen und Dips.",
  },
  {
    id: "desserts",
    title: "Lust auf Süßes",
    accent: "🍮",
    blurb: "Süßer Abschluss auf Griechisch.",
  },
  {
    id: "getraenke",
    title: "Getränke",
    accent: "🥂",
    blurb: "Kalte & warme Getränke, Fassbier, Wein und Cocktails.",
  },
];

// price as number for sorting; display rendered as "X,YZ €"
const dish = (id, name, price, desc, photoKey, opts = {}) => ({
  id,
  name,
  price,
  desc,
  photoKey,
  ...opts,
});

export const MENU = {
  vorspeisen: [
    dish("vp-platte", "Vorspeisenplatte", 13.9, "Ein Mix der Vorspeisen wie in Griechenland — perfekt zum Teilen.", "vorspeisenplatte", { featured: true }),
    dish("vp-zaziki", "Zaziki — Portion", 4.0, "Cremiger Joghurt-Gurken-Dip mit Knoblauch.", "zaziki"),
    dish("vp-zaziki-mini", "Zaziki — ein Schlag", 1.5, "Klassischer Joghurt-Knoblauch-Dip, ein Schlag auf dem Teller.", "zaziki"),
    dish("vp-fetacrema", "Fetacremé pikant", 4.9, "Cremige Schafskäse-Mousse mit feiner Schärfe.", "fetacrema"),
    dish("vp-oliven", "Oliven-/Peperonimix", 6.5, "Hausgemachter Mix aus Oliven und Peperoni.", "oliven"),
    dish("vp-dolmades", "Dolmadakia", 5.9, "Gefüllte Weinblätter mit Zaziki — original griechisch.", "dolmadakia"),
    dish("vp-saganaki", "Saganaki mit Honig", 7.5, "Gebackener griechischer Käse mit warmem Honig.", "saganaki", { featured: true }),
    dish("vp-aubergine", "Auberginen überbacken", 7.9, "Mit Tomatensauce und Mozzarella überbacken — vegetarisch.", "aubergine"),
    dish("vp-gigantes", "Gigantes", 7.9, "Dicke weiße Bohnen mit Käse überbacken.", "gigantes"),
    dish("vp-bruschetta", "Greek Pita-Bruschetta", 7.5, "Pita mit Tomate und Mozzarella überbacken.", "bruschetta"),
    dish("vp-pita", "Pitabrot mit Oregano", 1.5, "Frisch gebackenes Pitabrot mit Oreganowürzmischung.", "pita-bread"),
    dish("vp-pita-zaziki", "Pitabrot mit Oregano & Zaziki", 3.8, "Pita mit Würzmischung und einem Schlag Zaziki.", "pita-bread"),
    dish("vp-suppe", "Tomatensuppe mit Croûtons", 5.5, "Hausgemachte Tomatensuppe mit knusprigen Croûtons.", "tomatensuppe"),
    dish("vp-beilage", "Beilagen-Salat", 4.0, "Kleiner Salat als Beilage zu jedem Gericht.", "mista-salat"),
  ],

  salate: [
    dish("sa-mista", "Mista Salat", 9.9, "Grüner Salat, Minze und vieles aus dem Garten.", "mista-salat"),
    dish("sa-bauer", "Bauernsalat", 10.0, "Grüner Salat, Minze, Tomaten, Gurke, Zwiebeln, Schafskäse, Peperoni, Oliven.", "bauernsalat", { featured: true }),
    dish("sa-gyros-bauer", "Gyros auf Bauernsalat", 14.5, "Bauernsalat-Klassiker mit saftigem Gyros gekrönt.", "salat-chicken"),
    dish("sa-chicken", "Hähnchenbrustfilet Salat", 14.9, "Grüner Salat, Minze, Tomaten, Gurke, Ei, Walnüsse.", "salat-chicken"),
    dish("sa-capricciosa", "Capricciosa Salat", 10.5, "Grüner Salat, Minze, Tomaten, Gurke, Ei, Walnüsse.", "mista-salat"),
    dish("sa-capricciosa-tuna", "Capricciosa mit Thunfisch & Gouda", 14.9, "Capricciosa mit zusätzlichem Thunfisch und Gouda.", "salat-thunfisch"),
    dish("sa-lachs", "Lachsfilet auf Salat", 16.9, "Grüner Salat, Minze, Tomaten, Gurke, Zwiebeln, getr. Tomaten, Parmesanflocken.", "salat-lachs", { featured: true }),
    dish("sa-ziege", "Ziegenkäse auf Salat", 14.5, "Grüner Salat, Minze, Tomaten, Gurke, Walnüsse, getr. Tomaten.", "salat-ziege"),
    dish("sa-saganaki", "Saganaki auf Salat", 14.9, "Grüner Salat, Minze, Tomaten, Gurke, Zwiebeln — mit Saganaki gekrönt.", "salat-saganaki"),
  ],

  pita: [
    dish("p-offene", "Offene Pita Teller", 8.9, "Pitabrot, Gyros, Zwiebeln, Zaziki und Krautsalat.", "gyros-pita", { featured: true, photo: "/images/dishes/offene-pita.webp" }),
    dish("p-spezial", "Gyros Pita Spezial — aus dem Ofen", 10.9, "Pitabrot, Gyros mit Metaxasauce und Käse überbacken.", "gyros-baked", { featured: true }),
    dish("p-xxl", "Pitaburger XXL", 12.5, "2 Pitabrote, Gyros, Metaxasauce, Zwiebeln, Tomaten — mit Käse überbacken.", "gyros-baked"),
    dish("p-roll", "Gyros Pita eingerollt", 7.5, "Zwiebeln, Zaziki, Krautsalat — to go oder vor Ort.", "gyros-pita"),
    dish("p-roll-greek", "Gyros Pita Greek Art eingerollt", 7.9, "Tomaten, Zwiebeln, Zaziki mit Pommes.", "gyros-pita"),
    dish("p-veggie", "Pita vegetarisch eingerollt", 7.9, "Zaziki, Salat, Feta und Zwiebeln.", "gyros-pita"),
    dish("p-tasche", "Griechische Brottasche", 8.0, "Gefüllt mit grünem Salat, Zwiebeln, Tomaten, Zaziki, Krautsalat und Gyros.", "gyros-pita"),
  ],

  gyros: [
    dish("g-mini", "Gyros — kleine Portion", 7.5, "Saftiges Gyros vom Grill, kleine Portion.", "gyros-plate"),
    dish("g-mini-pommes", "Gyros — kleine Portion mit Pommes", 10.0, "Kleine Gyros-Portion mit goldgelben Pommes.", "gyros-plate"),
    dish("g-portion", "Gyros — Portion", 9.0, "Saftiges Gyros vom Grill, große Portion.", "gyros-plate", { featured: true }),
    dish("g-pommes", "Gyros mit Pommes", 10.9, "Gyros mit knusprigen Pommes.", "gyros-plate"),
    dish("g-salat", "Gyros mit Salat", 11.5, "Gyros mit Beilagen-Salat.", "gyros-plate"),
    dish("g-vollteller", "Gyros mit Pommes & Salat", 13.5, "Der vollständige Gyros-Teller.", "gyros-plate", { featured: true }),
    dish("g-pita-zaziki", "Gyros mit Pita, Zaziki & Zwiebeln", 12.5, "Pitabrot, Zaziki, Zwiebeln und Gyros.", "gyros-pita"),
    dish("g-metaxa", "Gyros mit Metaxasauce & Pommes", 12.5, "Gyros in cremiger Metaxasauce mit Pommes.", "gyros-plate", { featured: true }),
    dish("g-pommes-zaziki", "Gyros mit Pommes & Zaziki", 12.5, "Klassische Kombination: Pommes und Zaziki.", "gyros-plate"),
    dish("g-pfanne", "Gyrospfanne", 14.9, "Inkl. Pommes & Salat — Zwiebeln, Paprika, Champignons & Metaxasauce.", "gyros-pan", { featured: true }),
    dish("g-überbacken", "Gyros überbacken", 11.5, "Gyros mit Metaxa- oder Hollandaisesauce und Goudakäse überbacken.", "gyros-baked"),
    dish("g-überbacken-spezial", "Gyros überbacken — Spezial", 12.5, "Mit Zwiebeln, Peperoni und Fetakäse überbacken.", "gyros-baked"),
    dish("g-taxi", "Taxi Teller", 10.5, "Gyros, Currywurst und Pommes — der ehrliche Hunger-Teller.", "gyros-plate", { featured: true, photo: "/images/dishes/taxiteller.webp" }),
  ],

  grill: [
    dish("gr-1", "Grillteller I", 15.0, "Gyros, Souvlakispieß, 2 Cevapcici, Pita.", "vorspeisenplatte"),
    dish("gr-2", "Grillteller II", 16.0, "Gyros, Souvlakispieß, 2 Cevapcici, Schweinesteak, Pita.", "vorspeisenplatte"),
    dish("gr-3", "Grillteller III", 17.0, "Gyros, Souvlakispieß, 2 Cevapcici, Schweinesteak, Leber, Pita.", "vorspeisenplatte", { featured: true }),
    dish("gr-mix", "Grill-MIX-Teller", 17.0, "Gyros, Schweinesteak, 1 kleines Bifteki, Hähnchenfilet, Metaxasauce.", "vorspeisenplatte"),
    dish("gr-niko", "Niko's Teller", 17.9, "Gyros, Souvlakispieß, kleines Bifteki, Hähnchenfilet, Leber, Metaxasauce.", "vorspeisenplatte", { featured: true }),
    dish("gr-chicken", "Hähnchenbrustfilet vom Grill", 15.5, "Täglich frisch — Hähnchenfilets mit Sauce nach Wahl.", "chicken-grill"),
    dish("gr-leber", "Rinderleber vom Grill", 15.5, "Mit karamelisierten Röstzwiebeln.", "leber"),
    dish("gr-cevapcici", "Cevapciciteller", 14.5, "6 Cevapcici nach eigenem Rezept, mit Pita.", "cevapcici"),
    dish("gr-cevapcici-ofen", "Cevapciciteller aus dem Ofen", 15.5, "6 Cevapcici mit Metaxasauce und Käse überbacken.", "cevapcici"),
    dish("gr-souvlaki", "Souvlaki Teller", 14.5, "3 Spieße vom Schwein mit Pita.", "souvlaki", { featured: true }),
    dish("gr-bifteki", "Bifteki Teller", 15.0, "Hausgemachte Hack-Burger gefüllt mit Schafskäse.", "bifteki"),
    dish("gr-bifteki-mix", "Bifteki Teller MIX", 15.9, "Gyros, kleines Bifteki mit Metaxasauce.", "bifteki"),
    dish("gr-steak", "Schweinesteak Teller", 14.5, "3 Steaks mit Kräuterbutter.", "steak"),
    dish("gr-metaxa", "Metaxasteak Teller", 15.5, "3 Steaks aus Schweinefleisch mit Metaxasauce.", "steak"),
    dish("gr-pfeffer", "Pfeffersteak Teller", 16.0, "3 Steaks aus Schweinefleisch mit Pfeffersauce.", "steak"),
  ],

  schnitzel: [
    dish("sn-schwein", "Schnitzel vom Schwein", 8.5, "Klassisch paniert — ohne Beilagen.", "schnitzel"),
    dish("sn-haehnchen", "Hähnchenschnitzel", 8.9, "Knusprig paniertes Hähnchenschnitzel — ohne Beilagen.", "schnitzel"),
    dish("sn-jaeger", "Jägerschnitzel", 9.5, "Mit Champignon-Rahmsauce.", "schnitzel"),
    dish("sn-zigeuner", "Zigeunerschnitzel", 9.5, "Mit kräftiger Sauce aus Paprika und Zwiebeln.", "schnitzel"),
    dish("sn-holland", "Hollandaiseschnitzel", 9.5, "Mit Sauce Hollandaise.", "schnitzel"),
    dish("sn-metaxa", "Metaxaschnitzel", 9.5, "Mit hausgemachter Metaxasauce.", "schnitzel"),
    dish("sn-pfeffer", "Pfefferschnitzel", 10.5, "Mit cremiger Pfeffersauce.", "schnitzel"),
    dish("sn-rahm", "Rahmschnitzel", 10.5, "Mit cremiger Rahmsauce.", "schnitzel"),
    dish("sn-zwiebel", "Zwiebelschnitzel", 10.9, "Mit karamelisierten Röstzwiebeln, mit oder ohne Currysauce.", "schnitzel"),
    dish("sn-broccoli", "Broccolischnitzel", 11.0, "Mit Sauce Hollandaise & Käse überbacken.", "schnitzel"),
    dish("sn-hawaii", "Hawaiischnitzel", 11.0, "Mit Ananas, Sauce Hollandaise & Käse überbacken.", "schnitzel"),
    dish("sn-metaxa-ueberbacken", "Metaxaschnitzel überbacken", 11.0, "Metaxasauce mit Käse überbacken — Hausklassiker.", "schnitzel", { featured: true }),
    dish("sn-holstein", "Holsteinschnitzel", 12.0, "Mit Röstzwiebeln, Currysauce und 2 Spiegeleiern.", "schnitzel"),
    dish("sn-menue", "Schnitzel als Menüteller", 14.9, "Mit Pommes und Salat — als Jäger-, Zigeuner-, Metaxa- oder Hollandaiseschnitzel. Jede andere Sauce +1,00 €.", "schnitzel-menu", { featured: true }),
  ],

  burger: [
    dish("bg-home", "Home Burger", 10.9, "150 g Patty medium gegrillt, Cheddar, Tomaten, Zwiebeln, Salat, Spiegelei und Home Burger Sauce.", "burger", { featured: true }),
    dish("bg-chicken", "Chicken Burger", 12.5, "150 g Hähnchenfilet vom Grill, Cheddar, Tomaten, Zwiebeln, Salat, Spiegelei, Home Burger Sauce und Sweet Chili Sauce.", "burger"),
    dish("bg-greek", "Greek Style Burger", 12.9, "150 g Patty medium gegrillt, Cheddar, Saganaki, Tomaten, Zwiebeln, Salat, Home Burger Sauce und Fetacreme.", "burger", { featured: true }),
    dish("bg-bbq", "BBQ Burger", 12.5, "150 g Patty, Cheddar, BBQ Sauce, Tomaten, Salat, karamelisierte Röstzwiebeln, Bacon, Mayodip & Jalapeños.", "burger-bbq"),
    dish("bg-italia", "Italia Burger", 12.5, "150 g Patty, Mozarella, Tomaten-Zwiebel-Knoblauch-Mix, Salat & Pestocrema.", "burger"),
    dish("bg-tasso", "El Tasso Burger", 12.9, "150 g Patty, Feigensenf, Ziegenkäse, Salat, Tomaten, Mayodip & Feigensauce.", "burger"),
    dish("bg-veggie", "Veggie-Variante (Aufpreis)", 1.5, "Jeder Burger ist auch als Veggieburger erhältlich.", "burger-veggie"),
    dish("bg-patty", "Jedes weitere Patty (Aufpreis)", 4.5, "+150 g Patty für den großen Hunger.", "burger"),
    dish("bg-patty2", "Zwei weitere Pattys (Aufpreis)", 7.0, "+300 g Patty — die Maximalstufe.", "burger"),
  ],

  pasta: [
    dish("pa-aglio", "Aglio é Olio", 10.0, "Olivenöl, Cherrytomaten, Peperoncini und Knoblauch.", "pasta-aglio"),
    dish("pa-carbo", "Pasta Carbonara", 11.0, "Mit Speck und Sahnesauce — inklusive Parmesanflocken.", "pasta-carbonara"),
    dish("pa-spinat", "Spinat oder Broccoli", 11.0, "Mit Gorgonzola, Sahnesauce und Parmesan.", "pasta-aglio"),
    dish("pa-arrabbiata", "Arrabbiata", 12.5, "Oliven, Zwiebeln, Möhren, Paprika, Tomatensauce — scharf.", "pasta-bolognese", { featured: true }),
    dish("pa-chicken", "Spinat oder Broccoli mit Hähnchenbrustfilet", 14.5, "Mit Gorgonzola, Sahnesauce & Parmesan.", "pasta-bolognese"),
    dish("pa-lachs", "Pasta mit Lachsfilet", 15.5, "Lachs, Spinat, Parmesan und Sahnesauce.", "pasta-lachs", { featured: true }),
    dish("pa-kaese", "Mit Käse überbacken (Aufpreis)", 1.5, "Jede Pasta mit Goudakäse überbacken.", "pasta-aglio"),
    dish("pa-mozza", "Mit Mozzarella überbacken (Aufpreis)", 2.0, "Jede Pasta mit Mozzarella überbacken.", "pasta-aglio"),
  ],

  vegetarisch: [
    dish("vg-folie", "Folienkartoffel mit Zaziki", 4.9, "Die große Folienkartoffel mit cremigem Zaziki.", "folienkartoffel"),
    dish("vg-spinat", "Backkartoffel SPINAT", 11.9, "Mit Zwiebeln, Knoblauch, Hollandaisesauce und Käse überbacken.", "backkartoffel-spinat", { featured: true }),
    dish("vg-chicken", "Backkartoffel mit Hähnchenstreifen", 12.9, "Mit Zaziki oder Metaxasauce.", "hähnchen-streifen"),
    dish("vg-gyros", "Backkartoffel mit Gyros", 12.9, "Gyros, Metaxasauce, Champignons, Paprika und Zwiebeln.", "backkartoffel-spinat"),
  ],

  würste: [
    dish("wu-frikadelle", "Frikadelle", 3.5, "Hausgemachte Frikadelle.", "frikadelle"),
    dish("wu-pommes-metaxa", "Pommes mit Metaxasauce & Käse", 5.0, "Knusprige Pommes mit Metaxasauce und Käse überbacken.", "pommes-metaxa"),
    dish("wu-hamburger", "Hamburger / Cheeseburger", 5.5, "Klassisch — fair im Preis.", "burger"),
    dish("wu-crispychicken", "Crispychickenburger", 5.9, "Mit knusprigem Crispychicken.", "burger"),
    dish("wu-nuggets-6", "Chicken Nuggets — 6 Stück", 4.5, "6 knusprige Chicken Nuggets.", "nuggets"),
    dish("wu-nuggets-9", "Chicken Nuggets — 9 Stück", 6.0, "9 knusprige Chicken Nuggets.", "nuggets"),
    dish("wu-schaschlik", "Schaschlik", 7.3, "Hausgemacht, Magerfleisch.", "schaschlik"),
    dish("wu-brat", "Bratwurst", 3.5, "Klassische Bratwurst.", "bratwurst"),
    dish("wu-curry", "Currywurst", 4.0, "Currywurst mit hauseigener Sauce.", "currywurst"),
    dish("wu-curry-teller", "Curry Teller", 6.5, "Currywurst & Pommes — klassisch.", "currywurst", { featured: true, photo: "/images/dishes/currywurst-pommes.webp" }),
    dish("wu-jaeger", "Jäger-/Zigeunerwurst", 4.5, "Wurst mit Jäger- oder Zigeunersauce.", "currywurst"),
    dish("wu-metaxa", "Metaxa-/Pfefferwurst", 4.8, "Wurst mit Metaxa- oder Pfeffersauce.", "currywurst"),
    dish("wu-zwiebel", "Zwiebelwurst", 5.0, "Mit karamelisierten Röstzwiebeln und Currysauce.", "currywurst"),
  ],

  beilagen: [
    dish("be-pommes", "Pommes frites", 2.7, "Knusprig goldgelb.", "pommes"),
    dish("be-pommes-gross", "Pommes frites — große Portion", 4.7, "Doppelte Portion Pommes.", "pommes"),
    dish("be-pommes-spezial", "Pommes Spezial", 4.5, "Mit Currysauce, Mayonnaise und Zwiebeln.", "pommes"),
    dish("be-reis", "Reis", 3.0, "Lockerer Langkornreis.", "reis"),
    dish("be-kroketten", "Kartoffelkroketten — 6 Stück", 3.3, "6 knusprige Kroketten.", "kroketten"),
    dish("be-fleisch-kroketten", "Fleischkroketten — 1 Stück", 1.5, "Hausgemacht.", "kroketten"),
    dish("be-folienkartoffel", "Folienkartoffel mit Zaziki", 4.9, "Mit cremigem Zaziki.", "folienkartoffel"),
    dish("be-bratkartoffeln", "Bratkartoffeln", 4.5, "Aus der Pfanne mit Speck.", "bratkartoffeln"),
    dish("be-süß", "Süßkartoffeln", 4.9, "Goldbraun frittierte Süßkartoffeln.", "süßkartoffel"),
    dish("be-wedges", "Potatoes Wedges", 3.9, "Kartoffelspalten mit Schale.", "wedges"),
  ],

  saucen: [
    dish("sc-mayo", "Mayonnaise", 0.8, "Hausgemachte Mayonnaise.", "saucen"),
    dish("sc-curry", "Currysauce", 0.8, "Klassische Currysauce.", "saucen"),
    dish("sc-ketchup", "Ketchup", 0.8, "Tomatenketchup.", "saucen"),
    dish("sc-jaeger", "Jägersauce", 1.5, "Champignon-Rahmsauce.", "saucen"),
    dish("sc-aioli", "Aioli", 1.5, "Knoblauch-Mayonnaise.", "saucen"),
    dish("sc-zigeuner", "Zigeunersauce", 1.5, "Mit Paprika und Zwiebeln.", "saucen"),
    dish("sc-bbq", "BBQ Sauce", 1.5, "Süß-rauchig.", "saucen"),
    dish("sc-sweet", "Sweet Chili", 1.5, "Süß-scharf.", "saucen"),
    dish("sc-metaxa", "Metaxasauce", 2.5, "Hausgemacht — voll im Metaxa-Geschmack, aber ganz ohne Alkohol. Ein Genuss für die ganze Familie.", "saucen", { featured: true }),
    dish("sc-pfeffer", "Pfeffersauce", 2.5, "Cremige Pfeffersauce.", "saucen"),
    dish("sc-holland", "Hollandaise", 2.5, "Klassisch französisch.", "saucen"),
    dish("sc-rahm", "Rahmsauce", 2.5, "Cremig und mild.", "saucen"),
  ],

  desserts: [
    dish("de-loukouma", "Pita Loukouma", 6.5, "Gebackene Teigstangen mit Honig, Nutella und Bisquitthagel.", "saucen", { featured: true }),
    dish("de-joghurt", "Joghurt mit Honig & Walnüssen", 6.0, "Griechischer Joghurt, cremig und frisch.", "saucen"),
  ],

  getraenke: [
    dish("ge-cola", "Coca-Cola — 0,33 l", 3.5, "Spritzig aus der Flasche.", "saucen"),
    dish("ge-apfelschorle", "Apfelschorle — 0,25 l", 3.0, "Erfrischend spritzig.", "saucen"),
    dish("ge-wasser", "Wasser — 0,25 l", 3.0, "Still oder spritzig.", "saucen"),
    dish("ge-wasser-gross", "Wasser — 0,7 l", 7.5, "Die große Flasche für den Tisch.", "saucen"),
    dish("ge-vio", "ViO Schorle — 0,25 l", 3.5, "Johannisbeere oder Rhabarber.", "saucen"),
    dish("ge-maracuja", "Maracuja Schorle — 0,4 l", 4.5, "Fruchtig-exotisch.", "saucen"),
    dish("ge-fuzetea", "Fuzetea — 0,25 l", 3.0, "Pfirsich oder Zitrone.", "saucen"),
    dish("ge-veltins-03", "Veltins Pils / Radler — 0,3 l", 3.5, "Frisch gezapft vom Fass.", "saucen", { featured: true }),
    dish("ge-veltins-05", "Veltins Pils / Radler — 0,5 l", 4.5, "Frisch gezapft vom Fass.", "saucen"),
    dish("ge-veltins-frei", "Veltins Pils alkoholfrei — 0,33 l", 3.5, "Voller Geschmack, ohne Alkohol.", "saucen"),
    dish("ge-radler-frei", "Veltins Radler alkoholfrei — 0,5 l", 4.9, "Erfrischend, ohne Alkohol.", "saucen"),
    dish("ge-diebels", "Diebels Alt — 0,33 l", 3.5, "Klassisches Altbier.", "saucen"),
    dish("ge-frankenheimer", "Frankenheimer Blue — 0,33 l", 3.5, "Aus der Flasche.", "saucen"),
    dish("ge-weizen", "Weizenbier — 0,5 l", 4.9, "Hefeweizen aus der Flasche.", "saucen"),
    dish("ge-weizen-frei", "Weizenbier alkoholfrei — 0,33 l", 3.5, "Ohne Alkohol.", "saucen"),
    dish("ge-malz", "Malzbier — 0,33 l", 3.5, "Süß und malzig.", "saucen"),
    dish("ge-crema", "Café Crema", 2.5, "Frisch gebrüht.", "saucen"),
    dish("ge-espresso", "Espresso", 2.2, "Kräftig italienisch.", "saucen"),
    dish("ge-tee", "Tee — verschiedene Sorten", 2.2, "Roibusch, Früchte oder Kamille.", "saucen"),
    dish("ge-chardonnay", "Chardonnay — 0,1 l / 0,2 l", 2.9, "Trockener Weißwein. 0,2 l für 4,90 €.", "saucen"),
    dish("ge-grigio", "Pinot Grigio — 0,1 l / 0,2 l", 3.2, "Frischer Weißwein. 0,2 l für 4,90 €.", "saucen"),
    dish("ge-merlot", "Merlot — 0,1 l / 0,2 l", 2.9, "Fruchtiger, trockener Rotwein. 0,2 l für 4,90 €.", "saucen"),
    dish("ge-imiglikos", "Imiglikos — 0,1 l / 0,2 l", 2.9, "Lieblich, weiß oder rot. 0,2 l für 4,90 €.", "saucen"),
    dish("ge-rose", "Rosé — 0,1 l / 0,2 l", 2.9, "Trocken. 0,2 l für 4,90 €.", "saucen"),
    dish("ge-retsina", "Retsina — 0,1 l / 0,2 l", 2.9, "Geharzter griechischer Wein. 0,2 l für 4,90 €, Flasche 0,5 l für 9,90 €.", "saucen"),
    dish("ge-ouzo", "Ouzo — 2 cl", 2.0, "Der griechische Klassiker.", "saucen", { featured: true }),
    dish("ge-ramazotti", "Ramazotti — 2 cl", 2.5, "Auf Eis mit Zitrone (4 cl) für 4,50 €.", "saucen"),
    dish("ge-jaegermeister", "Jägermeister — 2 cl", 2.5, "Eiskalt serviert.", "saucen"),
    dish("ge-aperol", "Aperol Spritz", 6.5, "Der Sommerklassiker.", "saucen"),
    dish("ge-aperol-maracuja", "Aperol Maracuja", 6.9, "Fruchtige Variante mit Maracuja.", "saucen"),
  ],
};

export const ALLERGENS_NOTE =
  "Zusatzstoffe & Allergene werden auf Wunsch im Restaurant ausgewiesen. Diese Online-Karte dient zur Übersicht — verbindliche Angaben finden Sie in der Speisekarte vor Ort.";
